export const nudgeBeta = {
  ClientId: '4uh6a16iofhv26b1m9combd0ps', // Your client id here
  AppWebDomain: 'nudge-ui-beta.auth.us-west-1.amazoncognito.com',
  TokenScopesArray: ['openid'],
  RedirectUriSignIn: 'https://beta.nudge-ui.hr.amazon.dev/',
  RedirectUriSignOut: 'https://beta.nudge-ui.hr.amazon.dev/logout',
};

export const nudgeGamma = {
  ClientId: '61kbr1c0ccouesbtgi8ps96g5', // Your client id here
  AppWebDomain: 'beta-nudge-ui.auth.us-west-1.amazoncognito.com',
  TokenScopesArray: ['openid'],
  RedirectUriSignIn: 'https://beta.nudge-ui.hr.amazon.dev/',
  RedirectUriSignOut: 'https://beta.nudge-ui.hr.amazon.dev/logout',
};

export const nudgeProd = {
  ClientId: '11m0ghgojlbu3mjf8q5n80papv', // Your client id here
  AppWebDomain: 'nudge-api.auth.us-west-2.amazoncognito.com',
  TokenScopesArray: ['openid'],
  RedirectUriSignIn: 'https://nudge-ui.hr.amazon.dev/',
  RedirectUriSignOut: 'https://nudge-ui.hr.amazon.dev/logout',
};
